export enum SortType {
    ALPHABETICAL = 'alphabetical',
    DATE = 'date',
    GENERIC = 'generic'
}
